import {client} from '../helpers/api';

export async function getSubjects(gradeIds) {
  const qs = gradeIds?.length
    ? '?' + gradeIds.map((id) => `grade_id[]=${id}`).join('&')
    : '';

  const response = await client.get(`/api/subjects${qs}`);

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          subject_id: id,
          _grade_id: gradeId,
          subject_name: name,
          subject_image: image,
          subject_type: subjectType,
          language_code: languageCode,
          description,
        }) => ({
          id,
          gradeId,
          name,
          image,
          description,
          languageCode,
          subjectType,
        }),
      ) || []
    );
  }
  throw response;
}

// {
//     "subject_id": "f372e7e5-9030-4b1b-91c7-575f6c3a9e1e",
//     "_grade_id": "3c8d3bd8-9cf5-488e-a884-f51dc5afe576",
//     "subject_name": "Bahasa Melayu",
//     "subject_image": "bm.jpg",
//     "description": "",
//     "date_created": "2021-01-14 12:15:06",
//     "date_modified": "2021-01-14 12:15:06",
//     "status": "active",
//     "is_deleted": 0
// }
